<div class="login-desktop text">
  <form class="login-form" [formGroup]="loginDatas">
    <div class="login-item">
      <input placeholder="{{ 'user_name' | t }}" type="text" formControlName="userName" class="login-input" />
    </div>
    <div class="login-item">
      <input placeholder="{{ 'password' | t }}" type="password" formControlName="userPassword" class="login-input" />

      <div class="forget-pass">
        <a (click)="this._UiHelper.toogleForgotPass()" *ngIf="!env">{{ 'Forgot_Password' | t }}?</a>
      </div>
    </div>
  </form>
  <div class="item-row error-message-row" *ngIf="isError_fiveMinutes">
    <div class="error-message">{{ 'fiveminutes_error' | t }} {{ errorMessage }} {{ lastLoginDate | dateFormat : 'dd.MM.yyyy,hh:mm:ss' }}</div>
  </div>
  <div class="item-row">
    <div class="checkbox">
      <input type="checkbox" />
    </div>
    <div class="check-label">{{ 'AutoLogin' | t }}</div>
  </div>

  <div class="item-row" *ngIf="isError">
    <div class="btn colored register-button login-dropdown-btn" (click)="contactButton()">
      <div class="contact-btn-text">
        {{ 'Contact' | t }}
      </div>
    </div>
  </div>
  <div class="item-row" (click)="submitLoginData()">
    <div class="btn colored blue login-dropdown-btn">
      <div class="login-button-text">{{ 'Login' | t }}</div>
    </div>
  </div>

  <div class="item-row">
    <div class="unregister">{{ 'DontHaveAccount' | t }}</div>
    <div class="register" [routerLink]="['/register']">{{ 'Register' | t }}</div>
  </div>
</div>

<div class="login-mobile text">
  <div class="sidenav-header">
    <div class="left">{{ 'Login' | t }}</div>
    <div class="right" (click)="closeSideBar()">&times;</div>
  </div>
  <form class="login-mobile-form" [formGroup]="loginDatas">
    <div class="login-item">
      <inputb3 formControlName="userName" fPlaceholder="{{ 'user_name' | t }}" fInputType="input_text"></inputb3>
    </div>
    <div class="login-item">
      <inputb3 formControlName="userPassword" fPlaceholder="{{ 'password' | t }}" fInputType="password" extraClass="loginPassword"></inputb3>
      <div class="forget-pass" (click)="this._UiHelper.toogleForgotPass()">{{ 'Forgot_Password' | t }}?</div>
    </div>
  </form>
  <div class="login-container">
    <div class="item-row error-message-row" *ngIf="isError_fiveMinutes">
      <div class="error-message">{{ 'fiveminutes_error' | t }} {{ errorMessage }} {{ lastLoginDate | dateFormat : 'dd.MM.yyyy,hh:mm:ss' }}</div>
    </div>
    <div class="login-row" (click)="submitLoginData()">
      <div class="btn mobile colored register-button">
        <div class="btn-text mobile-text-white">
          {{ 'Login' | t }}
        </div>
      </div>
    </div>
    <div class="login-row">
      <div class="checkbox">
        <input type="checkbox" />
      </div>
      <div class="check-label">{{ 'AutoLogin' | t }}</div>
    </div>
    <div class="login-row" *ngIf="isError">
      <div class="btn mobile colored register-button" (click)="contactButton()">
        <div class="btn-text mobile-text-white">
          {{ 'Contact' | t }}
        </div>
      </div>
    </div>
    <div class="login-row" *ngIf="this.IsRegisterActive">
      <div class="btn mobile colored green">
        <div class="btn-text mobile-text-white" (click)="closeSideBar()" [routerLink]="['/register']">
          {{ 'RegisterNow' | t }}
        </div>
      </div>
    </div>
  </div>
</div>
